import {Modal} from 'react-bootstrap'
import React from 'react'
import PropTypes from 'prop-types'
import './SimpleInfoModal.css'

class SimpleInfoModal extends React.Component {
  render(){
    const {show,content} = this.props

    return <Modal show={show}>
      <Modal.Header bsClass='simple-info-modal__header modal-header'>
        <span>Information</span>
      </Modal.Header>
      <Modal.Body>
        {content}
      </Modal.Body>
      <Modal.Footer>
        <button className='btn btn-default' onClick={this._onClickConfirm}>OK</button>
      </Modal.Footer>
    </Modal>
  }

  _onClickConfirm = () => {
    this.props.onClickConfirm({})
  }

}


SimpleInfoModal.propTypes = {
  show: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
  onClickConfirm: PropTypes.func
}


export default SimpleInfoModal


// WEBPACK FOOTER //
// app/javascript/components/SimpleInfoModal/SimpleInfoModal.js